module.exports = __webpack_public_path__ + "static/media/home-layout-menu-one.db414d11.png";